export const openingHoursDayOptions = [
  { value: "monday", label: "Montag" },
  { value: "tuesday", label: "Dienstag" },
  { value: "wednesday", label: "Mittwoch" },
  { value: "thursday", label: "Donnerstag" },
  { value: "friday", label: "Freitag" },
  { value: "saturday", label: "Samstag" },
  { value: "sunday", label: "Sonntag" },
];

const DAY_ORDER_MAP = openingHoursDayOptions.reduce((acc, option, index) => {
  acc[option.value] = index;
  return acc;
}, {});

export const getOpeningDayLabel = (value) => {
  if (!value) return "";
  const match = openingHoursDayOptions.find((item) => item.value === value);
  if (match) return match.label;
  return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
};

export const sortOpeningHoursByDay = (hours = []) =>
  [...hours].sort(
    (a, b) =>
      (DAY_ORDER_MAP[a?.day] ?? Number.MAX_SAFE_INTEGER) -
      (DAY_ORDER_MAP[b?.day] ?? Number.MAX_SAFE_INTEGER)
  );

const compareTime = (a = "", b = "") => {
  if (a === b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a.localeCompare(b);
};

export const normalizeDayValues = (values = []) => {
  const valueArray = Array.isArray(values) ? values : values ? [values] : [];
  const normalized = valueArray
    .map((entry) => String(entry || "").trim().toLowerCase())
    .filter((day) => DAY_ORDER_MAP[day] !== undefined);
  const unique = [...new Set(normalized)];
  return unique.sort(
    (a, b) =>
      (DAY_ORDER_MAP[a] ?? Number.MAX_SAFE_INTEGER) -
      (DAY_ORDER_MAP[b] ?? Number.MAX_SAFE_INTEGER)
  );
};

export const sortTrainingSessions = (sessions = []) =>
  [...sessions].sort((a, b) => {
    const normalizeDays = (entry) => {
      const days =
        Array.isArray(entry?.days) && entry.days.length
          ? entry.days
          : entry?.day
          ? [entry.day]
          : [];
      return normalizeDayValues(days);
    };
    const aDays = normalizeDays(a);
    const bDays = normalizeDays(b);
    const aOrder =
      aDays.length > 0
        ? DAY_ORDER_MAP[aDays[0]] ?? Number.MAX_SAFE_INTEGER
        : Number.MAX_SAFE_INTEGER;
    const bOrder =
      bDays.length > 0
        ? DAY_ORDER_MAP[bDays[0]] ?? Number.MAX_SAFE_INTEGER
        : Number.MAX_SAFE_INTEGER;
    const dayDiff = aOrder - bOrder;
    if (dayDiff !== 0) return dayDiff;
    const timeDiff = compareTime(a?.start, b?.start);
    if (timeDiff !== 0) return timeDiff;
    return 0;
  });
